module.exports = __webpack_public_path__ + "static/mainLogo-7bcccdda2061c7551a82ec537f2e875a.png";